export default "__VITE_ASSET__DQeShQlp__"